import classNames from 'classnames';
import React, { ReactNode, useEffect, useRef, useState } from 'react';
import './index.less';

interface IProps {
    children: ReactNode;
    visible: boolean;
    wrapClassName?: string;
}
const DrawerBox: React.FC<IProps> = props => {
    // 获取屏幕宽度
    const screenWidth = window.innerWidth;
    // 获取屏幕高度
    const screenHeight = window.innerHeight;

    const [isMoving, setMoving] = useState(false);
    const boxRef = useRef<any>();

    // 鼠标点击时 记录偏移位置
    const originPositionRef = React.useRef({
        deltaX: 0,
        deltaY: 0,
    });

    // 确定极限范围
    const rangeRef = useRef({
        minX: 0,
        maxX: 0,
        minY: 0,
        maxY: 0,
    });

    // 确定偏移量
    const [position, setPosition] = useState({
        x: 0,
        y: 0,
    });

    /**
     * 计算可视窗口移动距离
     */
    const calcPositionRange = (e: any) => {
        // 可视窗口高度 宽度
        const windowWidth = document.documentElement.clientWidth;
        const windowHeight = document.documentElement.clientHeight;

        // 当前可拖动元素高度 宽度
        const drawerBoxWidth = boxRef.current.clientWidth;
        const drawerBoxHeight = boxRef.current.clientHeight;

        // 当前元素距离窗口顶部左边距离
        const offsetTop = boxRef.current.offsetTop;
        const offsetLeft = boxRef.current.offsetLeft;

        rangeRef.current = {
            minX: -offsetLeft,
            maxX: windowWidth - offsetLeft - drawerBoxWidth,
            minY: -offsetTop,
            maxY: windowHeight - offsetTop - drawerBoxHeight,
        };
    };

    const onMouseUp = (event: any) => {
        // 鼠标移动
        if (isMoving) {
            let x = event.pageX - originPositionRef.current.deltaX;
            let y = event.pageY - originPositionRef.current.deltaY;
            // 判断x y轴最大值 最小值
            y = y > rangeRef.current.maxY ? rangeRef.current.maxY : y;
            y = y < rangeRef.current.minY ? rangeRef.current.minY : y;
            x = x > rangeRef.current.maxX ? rangeRef.current.maxX : x;
            x = x < rangeRef.current.minX ? rangeRef.current.minX : x;
            setPosition({
                x,
                y,
            });
            setMoving(false);
        }
    };

    const onMouseDown: React.MouseEventHandler<HTMLDivElement> = (event: any) => {
        // 鼠标按下
        if (event.button !== 0) return;
        event.preventDefault();
        event.stopPropagation();
        // 进行定位 确定最大范围
        calcPositionRange(event);
        originPositionRef.current.deltaX = event.pageX - position.x;
        originPositionRef.current.deltaY = event.pageY - position.y;
        setMoving(true);
    };

    const onMouseMove = (event: MouseEvent) => {
        if (isMoving) {
            setPosition({
                x: event.pageX - originPositionRef.current.deltaX,
                y: event.pageY - originPositionRef.current.deltaY,
            });
        }
    };

    useEffect(() => {
        window.addEventListener('mouseup', onMouseUp);
        window.addEventListener('mousemove', onMouseMove);
        return () => {
            window.removeEventListener('mouseup', onMouseUp);
            window.removeEventListener('mousemove', onMouseMove);
        };
    }, [isMoving]);

    return props.visible ? (
        <div
            className={classNames('financeWordDrawer', props.wrapClassName)}
            onMouseDown={onMouseDown}
            ref={boxRef}
            style={{
                top: screenHeight / 2 - 180,
                left: screenWidth / 2 - 360,
                transform: `translate3d(${position.x}px, ${position.y}px, 0)`,
                transition: 'transform .3s cubic-bezier(.215,.61,.355,1) 0s',
                transitionDuration: isMoving ? '0s' : '0.3s',
                cursor: isMoving ? 'grabbing' : 'grab',
                // cursor: 'grab',
            }}
        >
            {props.children}
        </div>
    ) : null;
};

export default DrawerBox;
